<template>
  <b-modal
    centered
    :hide-footer="true"
    :hide-header="true"
    modal-class="c-wrap"
    dialog-class="c-dialog2"
    content-class="c-content"
    body-class="c-body-no-padding container"
    :visible="visible"
    @show="getQuizList(); show()"
    @hide="hide"
  >
    <div class="container" style="padding:0 23px">
    <div class="signup-logo" >
      <img src="../../../assets/image/ic_logo@2x.png" style="width: 60px; height: 60px; margin-top: 30px;"/>
    </div>
      <div class="title_wrapper title" style="margin-left: 0;">{{ $t('signup_quiz.title') }}</div>
      <div class="quiz_list">
        <div v-for="(quiz, index) in list" class="quiz_item">
          <div class="quiz">{{(index+1) +'. '+ quiz.f_question}}</div>
          <div style="margin-top: 10px">
            <MdSingleCheckBox v-for="(answer, idx) in quiz.f_answer_list"
                              :label="answer"
                              :label-color="quiz.f_answer_idx == idx? $c.Color.$primary: ''"
                              label-position="right"
                              label-class="answer_text"
                              @click="selectAnswer(index, idx)"
                              :state="quiz.f_answer_idx == idx"
                              style="margin-bottom: 6px;"
            />
          </div>

        </div>
      </div>
      <b-button class="signup_btn signup_label" @click="onSignup">{{$t('signup_quiz.apply_subscription')}}</b-button>
      <div style="padding:1px;" ></div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import MdSingleCheckBox from "../mf/MdSingleCheckBox";

const u = require('util');
export default {
  name: "SignupQuizPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    info:{
      type:Object,
    }
  },
  components:{
    MdSingleCheckBox
  },
  data() {
    return {
      list:[],
    }
  },
  methods:{
    selectAnswer(quiz_idx, answer_idx){
        this.list = this.list.map((it, idx) => {
          if (idx == quiz_idx) {
            it.f_answer_idx = answer_idx;
          }
          return it;
        });
    },
    hide(){
      this.$emit('update:visible', false);
    },
    getQuizList(){
      Utils.requestGet(
        this.$c.API.Auth.getCertQuestionList,
        {}
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          result.data.list.forEach(it => {
            it.f_answer_idx = -1;
          });
            this.list = result.data.list;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onSignup() {
      let {list, info} = this;

      if (list.some(it => {
        return it.f_answer_idx == -1
      })) {
        Utils.toast(this, this.$t('signup_quiz.select_answer'));
        return;
      }

      let answerList = list.map((it, idx) => {
        return {
          'q_id': it.f_idx,
          "a_index": it.f_answer_idx
        }
      });

      Utils.showConfirm(
        this,
        "<span style='line-height: 3;'>"+this.$t('signup_quiz.dlg_title')+"</span>" +
        //"<br>" +
        // "<span style='font-size:20px; font-family:KoreanGD15R; color: #0840ba; text-decoration: underline;'>"+this.$t('signup_quiz.dlg_content2')+"</span>" +
        "<br>" +
        "<span style='font-size:20px; font-family:KoreanGD14R; color: #0840ba;'>"+this.$t('signup_quiz.dlg_content2')+"</span>" +
        "<br>" +
        "<div style='margin-bottom: 15px;'></div>" +
        "<span style='color: #cf0000; font-size:20px; font-family:KoreanGD14R;'>" + this.$t('signup_quiz.dlg_content')+"</span>" +
        "<br>" +
        "<span style='color: #cf0000; font-size:20px; font-family:KoreanGD14R;'>" + u.format(this.$t('signup_quiz.dlg_content1'), '00:00') + "</span>",).then(
        val => {
          if (val) {
            if (info != null) {
              info.answer_list = JSON.stringify(answerList);
              Utils.requestPost(
                this.$c.API.Auth.signUp,
                info
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  if (result.data == null) {
                    this.$router.push('login');
                    this.eventBus.$emit('show_toast');
                    return;
                  }

                  this.myinfo.accessToken = result.data.access_token;

                  this.$perf.setString(this.$c.PREF_PARAMS.PHONE, info.phone_number);
                  this.$perf.setString(this.$c.PREF_PARAMS.CODE, info.code);

                  this.getProfile();
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            } else {
              // Update Cert Answer
              Utils.requestPost(
                this.$c.API.Auth.updateCertAnswer,
                {
                  phone: this.phone,
                  answer_list: JSON.stringify(answerList)
                }
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  this.$router.push('login');
                  this.eventBus.$emit('show_toast');
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        });
    },
    getProfile(){
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.$router.push('home');
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    show() {
      var self = this;
      history.pushState({data:1},"temp");
    }
  },
  inject: ['eventBus'],
  computed:{
  },
  watch:{
  },


}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
@import "../../../assets/css/auth/SignupInfo";
@import "../../../assets/css/auth/SignupQuiz";
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SignupQuizPopup.vue